import React from 'react';
import {
  Button,
  FormHelperText,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Grid,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { alphabeticRegex } from './../../../Utils';
const AddBasicDetails = ({
  stateType,
  setStateType,
  errors,
  handleUpload,
  onPanBlur,
  relationList,
  age,
  today,
  uploadedFileName,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <FormControl
          fullWidth
          error={!!errors.pancard_no}
        >
          <TextField
            fullWidth
            name='pancard_no'
            type='text'
            value={stateType.pancard_no}
            onChange={(e) => {
              setStateType({
                ...stateType,
                pancard_no: e.target.value,
              });
            }}
            onBlur={(e) => onPanBlur(e, setStateType)}
            label='PAN Number'
          />
          {errors.pancard_no && (
            <FormHelperText>{errors.pancard_no}</FormHelperText>
          )}
        </FormControl>
      </Grid>
      {/* Beneficiary PAN */}
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth>
          <Button
            sx={{ p: '1rem' }}
            component='label'
            variant='contained'
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
          >
            Upload Pan card
            <input
              hidden
              type='file'
              id='fileUpload'
              onChange={(e) => handleUpload(e)}
              accept='.jpeg, .jpg, .png'
            />
          </Button>
          {uploadedFileName && (
            <Typography variant="body2" sx={{ mt: 1, color: 'black' }}>
              Uploaded File: {uploadedFileName}
            </Typography>
          )}

        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl
          fullWidth
          error={!!errors.first_name}
        >
          <TextField
            fullWidth
            name='first_name'
            type='text'
            value={stateType.first_name}
            onChange={(e) => {
              const value = e.target.value;
              if (alphabeticRegex.test(value)) {
                setStateType({
                  ...stateType,
                  first_name: value,
                });
              }
            }}
            label='First Name'
          />
          {errors.first_name && (
            <FormHelperText>{errors.first_name}</FormHelperText>
          )}
        </FormControl>
        {/* Beneficiary First name */}
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl
          fullWidth
          error={!!errors.last_name}
        >
          <TextField
            fullWidth
            name='last_name'
            type='text'
            value={stateType.last_name}
            onChange={(e) => {
              const value = e.target.value;
              if (alphabeticRegex.test(value)) {
                setStateType({
                  ...stateType,
                  last_name: value,
                });
              }
            }}
            label='Last Name'
          />
          {errors.last_name && (
            <FormHelperText>{errors.last_name}</FormHelperText>
          )}
        </FormControl>
        {/* Beneficiary Last name */}
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl
          error={!!errors.phone_no}
          fullWidth
        >
          <TextField
            fullWidth
            name='phone_no'
            type='text'
            value={stateType.phone_no}
            onChange={(e) => {
              if (/^\d*$/.test(e.target.value) && e.target.value.length <= 10) {
                setStateType({
                  ...stateType,
                  phone_no: e.target.value,
                });
              }
            }}
            label='Phone Number'
          />
          {errors.phone_no && <FormHelperText>{errors.phone_no}</FormHelperText>}
        </FormControl>
      </Grid>
      
      <Grid item xs={12} sm={6}>
        <FormControl
          error={!!errors.email}
          fullWidth
        >
          <TextField
            fullWidth
            name='email'
            type='email'
            value={stateType.email}
            onChange={(e) => {
              setStateType({
                ...stateType,
                email: e.target.value,
              });
            }}
            label='Email'
          />
          {errors.email && <FormHelperText>{errors.email}</FormHelperText>}
        </FormControl>
        {/* Beneficiary Email */}
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl
          error={!!errors.date_of_birth}
          fullWidth
        >
          <TextField
            label='Date of Birth'
            type='date'
            InputLabelProps={{ shrink: true }}
            InputProps={{ inputProps: { max: today } }}
            value={stateType.date_of_birth}
            onChange={(e) => {
              setStateType({
                ...stateType,
                date_of_birth: e.target.value,
              });
            }}
            name='date_of_birth'
          />
          {errors.date_of_birth && (
            <FormHelperText>{errors.date_of_birth}</FormHelperText>
          )}
        </FormControl>
        {/* Beneficiary Date of birth */}
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl
          error={!!errors.relation}
          fullWidth
          sx={{ mb: 2 }}
        >
          <InputLabel>Select Relation</InputLabel>
          <Select
            label='Select Relation'
            value={stateType.relation}
            onChange={(e) => {
              setStateType({
                ...stateType,
                relation: e.target.value,
              });
            }}
            name='relation'
          >
            {relationList.map((item, i) => (
              <MenuItem
                key={i}
                value={item}
              >
                {item}
              </MenuItem>
            ))}
          </Select>
          {errors.relation && <FormHelperText>{errors.relation}</FormHelperText>}
        </FormControl>
      </Grid>

      {stateType.date_of_birth && (
        <Grid item xs={12}>
          <Typography>Age : {age}</Typography>
        </Grid>
      )}
      {/* {age !== null &&
        !isNaN(age) &&
        (age > 60 ? (
          <Typography sx={{ color: 'error.main' }}>
            Benefits are not available for age more than 60 years
          </Typography>
        ) : age < 18 ? (
          <Typography sx={{ color: 'error.main' }}>
            Please contact Support for minor beneficiary
          </Typography>
        ) : null)} */}
      {age !== null && !isNaN(age) && (
        <Grid item xs={12}>
          {age > 60 ? (
            <Typography sx={{ color: 'error.main' }}>
              Benefits are not available for age more than 60 years
            </Typography>
          ) : age < 18 ? (
            <Typography sx={{ color: 'error.main' }}>
              Please contact Support for minor beneficiary
            </Typography>
          ) : null}
        </Grid>
      )}
    </Grid>
  );
};
export default AddBasicDetails;
